import { ISmartSimulation,getDefaultSmartSimulation } from "./ISmartSimulation"

export interface ISmartMission extends ISmartSimulation {
    simulation_company:string			
    simulation_name:string
	simulation_iteration:number|null
}

export function getDefaultSmartMission() {
	return {
		...getDefaultSmartSimulation(),
		simulation_company:"",
		simulation_name:"",
		simulation_iteration:null
	} as ISmartSimulation
}